export const Admin_Route = '/admin'
export const Registration_Route = '/registration'
export const MainMenu_Route = '/'
export const login_route = '/login'
export const Attractions_route = '/attractions'
export const AddAttraction_route = '/addAttraction' 
export const Profile_route = '/profile'
export const Attendance_route ='/attendance'
export const Users_route = '/USERSLIST'